import { AutogenLayoutSeatingDriver } from "./autogen/AutogenLayoutSeatingDriver";
import { Button, DataSourceAction, DataSourceExecutionEvent, DataSourceMode, Layout, LookupModelSearchEvent, SlideoutDecorator, SlideoutDecoratorProps, TableRow, TableSelectionEvent, Toast } from "@mcleod/components";
import { Action } from "./Seating";
import { CommonDialogs } from "@mcleod/common";
import { CityUtil } from "@mcleod/core";

interface SeatingDriverSlideoutProps {
    id: string;
    name: string;
    doAfterSave?: () => void;
}

export class SeatingDriver extends AutogenLayoutSeatingDriver {
    static async showSlideout(props: SeatingDriverSlideoutProps, slideoutProps?: Partial<SlideoutDecoratorProps>) {
        const layout = Layout.getLayout("lme/dispatch/asset/SeatingDriver") as SeatingDriver;
        await layout.ensureLoaded();
        layout.mainDataSource.addAfterExecutionListener((event: DataSourceExecutionEvent) => {
            if (event.getAction() == DataSourceAction.ADD) {
                layout.slideOut().then(() => {
                    props.doAfterSave?.();
                    Toast.showSuccessToast("Driver successfully seated");
                });
            }
        });
        layout.mainDataSource.addBeforeExecutionListener((event: DataSourceExecutionEvent) => {
            if (event.getAction() == DataSourceAction.ADD) {
                layout.activeRow.set("team_driver_changed", layout.activeRow.getChangedData()?.hasOwnProperty("driver_two_id"))
            }
        });
        layout.mainDataSource.addAfterModeChangeListener(() => {
            if (layout.mainDataSource.mode !== DataSourceMode.ADD)
                return;
            layout.activeRow.setValueAndLookupModelData("driver_id", props.id, { id: props.id, name: props.name });
            layout.activeRow.set({ date: new Date() });
        });

        const saveButton = new Button({
            rowBreak: false,
            caption: "Save & Close",
            backgroundColor: "primary",
            borderWidth: 0,
            color: "primary.reverse",
            onClick: () => {
                if (layout.layoutOrderPlanningUnseatedTractor.tableUnseatedTractor.selectedRow == null) {
                    CommonDialogs.showError("Please select your tractor.");
                    return;
                }
                saveButton.busy = true;
                layout.mainDataSource.post().finally(() => {
                    saveButton.busy = false;
                    layout.slideOut();
                });
            }
        });
        SlideoutDecorator.decorateAndSlideIn(layout, {
            fillVerticalSpace: true,
            width: "60%",
            title: `Seating Driver - ${props.name}`,
            addlComponents: [saveButton],
            doAfterSlideIn: () => {
                layout.layoutOrderPlanningUnseatedTractor.tableUnseatedTractor.fillHeight = true;
                layout.layoutOrderPlanningUnseatedTractor.tableUnseatedTractor.addSelectionListener((event: TableSelectionEvent) => {
                    if (!event.newRow)
                        return;
                    const selectedRow: TableRow = event.newRow;
                    const modelRow = selectedRow.data;
                    const tractorId = modelRow.get("tractor.id");
                    layout.locationTractor.textCombined.clear();
                    layout.activeRow.set({
                        action: Action.SEAT,
                        assigned_driver_changed: true,
                        tractor_id: tractorId,
                        _lookup_tractor_id: { id: tractorId, name: tractorId },
                        city_id: modelRow.get("stop.city_id"),
                        city_name: modelRow.get("stop.city_name"),
                        address: modelRow.get("stop.address"),
                        zip_code: modelRow.get("stop.zip_code"),
                        state: modelRow.get("stop.state"),
                        location_id: modelRow.get("stop.location_id"),
                        location_name: modelRow.get("stop.location_name")
                    });
                });
            },
            ...slideoutProps
        });
    }

    textboxDriverSeatedBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.is_active = "Y";
    }

    textboxDriverTwoBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.is_active = "Y";
    }

    labelLocationIdOnDataDisplay() {
        this.labelCSZ.text = CityUtil.formatCityStateZip(this.activeRow.get("city_name"), this.activeRow.get("state"), this.activeRow.get("zip_code"));
        this.labelCSZ.visible = this.labelCSZ.hasText();
    }
}
